import compileSymbols from '~/utils/compileSymbols';

const types = [
  'ALIGN',
  'ALIGN_CENTER',
  'ALIGN_MIDDLE',
  'ALIGN_TOP',
  'ALIGN_BOTTOM',
  'ALIGN_LEFT',
  'ALIGN_RIGHT',
  'BACKWARD',
  'BACKWARD_STEP',
  'CENTER',
  'CHANGE_COLOR',
  'CHANGE_PLACEMENT',
  'COPY',
  'CROP',
  'CUT',
  'DISTRIBUTE_HORIZONTAL',
  'DISTRIBUTE_VERTICAL',
  'DUPLICATE',
  'FORWARD',
  'FORWARD_STEP',
  'MOVE',
  'PASTE',
  'REMOVE',
  'RESET_CLIPART_COLORS',
  'RESIZE',
  'RESTORE',
  'ORDER_RECENT_UPLOADS',
  'ROTATE',
  'SET_VIEW',
  'UPDATE_HORIZONTAL_FLIP',
  'UPDATE_VERTICAL_FLIP',
  'UPDATE_SINGLE_COLOR',
  'UPDATE_SINGLE_COLOR_AND_CONTRAST',
  'UPDATE_CONTRAST',
  'UPDATE_INVERT_CONTRAST',
  'UPDATE_POSITION',
  'TOGGLE_INVERTED_CLIPART'
];

export default compileSymbols(types, 'icon');
